// extracted by mini-css-extract-plugin
module.exports = {"formContent":"form_formContent__BR_6o"};